export class Mastermind {
    public LegendaryMasterMindId: number = 0;
    public UserName:string = "";
    public Name: string = "";
    public Commander: boolean = false;

    public Attack: number = 0;
    public Special: boolean = false;
    public Bribe: boolean = false;
    public CosmicThreat: boolean = false;
    public AlwaysLeads: string = "";

    public DisplayClass: string = "";
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Apps/legendary/models/mastermind.ts